'use client';

import { createContext, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { Locale as DateFnsLocale } from 'date-fns';

import { DEFAULT_LOCALE, Locale, loadDateFnsLocale } from './utils';

interface I18nContextData {
  locale: Locale;
  dateFnsLocale?: DateFnsLocale;
}

export const I18nContext = createContext<I18nContextData>({
  locale: DEFAULT_LOCALE,
});

interface I18nProviderProps {
  locale: string;
  messages: Record<string, string>;
  children: React.ReactNode;
}

export const I18nProvider = ({
  locale,
  messages,
  children,
}: I18nProviderProps) => {
  const [dateFnsLocale, setDateFnsLocale] = useState<DateFnsLocale>();

  useEffect(() => {
    const initializeDateFnsLocale = async () => {
      const dateFnsLocale = await loadDateFnsLocale(locale as Locale);
      setDateFnsLocale(dateFnsLocale);
    };

    initializeDateFnsLocale();
  }, [locale]);

  return (
    <IntlProvider
      messages={messages}
      locale={locale}
      defaultLocale={DEFAULT_LOCALE}
    >
      <I18nContext.Provider value={{ locale: locale as Locale, dateFnsLocale }}>
        {children}
      </I18nContext.Provider>
    </IntlProvider>
  );
};
